import React, { useState } from 'react';
import {
    Drawer, Box, Typography, IconButton, Button, Slider,
    FormControlLabel, Checkbox, Accordion, AccordionSummary, AccordionDetails, TextField
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const MedicinesFilterDrawer = ({
                                   open,
                                   onClose,
                                   onFilterChange
                               }) => {
    const [filters, setFilters] = useState({
        manufacturer: '',
        category: '',
        dosage: '',
        form: '',
        priceRange: [0, 200],
        availability: {
            inStock: false,
        },
        status: '',
    });

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        if (name in filters.availability) {
            setFilters((prev) => ({
                ...prev,
                availability: { ...prev.availability, [name]: value },
            }));
        } else {
            setFilters((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handlePriceRangeChange = (event, newValue) => {
        setFilters((prev) => ({
            ...prev,
            priceRange: newValue,
        }));
    };

    const handleApplyFilters = () => {
        onFilterChange(filters);
        onClose();
    };

    const handleClearFilters = () => {
        const cleared = {
            manufacturer: '',
            category: '',
            dosage: '',
            form: '',
            priceRange: [0, 200],
            availability: {
                inStock: false,
            },
            status: '',
        };
        setFilters(cleared);
        onFilterChange({});
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose} sx={{ width: 400 }}>
            <Box sx={{ p: 3, width: 400 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Filter</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Basic Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            fullWidth
                            label="Manufacturer"
                            name="manufacturer"
                            value={filters.manufacturer}
                            onChange={handleFilterChange}
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            fullWidth
                            label="Category"
                            name="category"
                            value={filters.category}
                            onChange={handleFilterChange}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Dosage and Form</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            label="Dosage"
                            name="dosage"
                            value={filters.dosage}
                            onChange={handleFilterChange}
                            fullWidth
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            label="Form"
                            name="form"
                            value={filters.form}
                            onChange={handleFilterChange}
                            fullWidth
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Price Range</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>${filters.priceRange[0]} - ${filters.priceRange[1]}</Typography>
                        <Slider
                            value={filters.priceRange}
                            onChange={handlePriceRangeChange}
                            valueLabelDisplay="auto"
                            min={0}
                            max={500}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Availability</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={filters.availability.inStock}
                                    onChange={(e) =>
                                        handleFilterChange({
                                            target: { name: 'inStock', value: e.target.checked },
                                        })
                                    }
                                />
                            }
                            label="In Stock"
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography>Status</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TextField
                            label="Status"
                            name="status"
                            value={filters.status}
                            onChange={handleFilterChange}
                            fullWidth
                        />
                    </AccordionDetails>
                </Accordion>

                <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
                    <Button variant="outlined" onClick={handleClearFilters}>Clear</Button>
                    <Button variant="contained" onClick={handleApplyFilters}>Apply</Button>
                </Box>
            </Box>
        </Drawer>
    );
};

export default MedicinesFilterDrawer;
